import ApiService from "./ApiService";
import { stringify } from "querystring";
import { format } from "util";

const ENDPOINTS = {
  GET_TRANSACTIONS: "transactions/",
  GET_TRANSACTION: "transactions/%s/",
  DELETE_TRANSACTION: "transactions/%s/",
  START_TRANSACTIONS_DOWNLOAD: "transactions/download-report/",
  TRANSACTIONS_DOWNLOAD_RESULTS: "transactions/report/",
  GET_MARKETING_REPORTING: "marketing-reporting/%s",
  GET_CAMPAIGN_PERFORMANCE: "best-campaign/",
  CONNECT_CONTACT_AND_TRANSACTION: "transactions/connect_contact/",
  REMOVE_CONTACT_FROM_TRANSACTION: "transactions/remove_contact/",
  GET_TREATMENTS: "contacts/treatments/",
  PARTIAL_UPDATE_TRANSACTIONS: "transactions/%s/",
  CONNECT_APPOINTMENT: "transactions/%s/connect_appointment/",
  PRODUCTS_EXTRA: "transactions/products_extra/",
  TOTAL_APPT_SCHEDULED: "service/reporting/total_appt_sch/",
  TOP_SERVICE_RATE: "service/reporting/top-services/",
  PROVIDERS_PRODUCTIVITY_RATE: "service/reporting/productivity/",
  STAFF_UTALIZATION: "service/reporting/staff-utilization/",
  NO_SHOW_RATE: "service/reporting/canceled/",
  LEAD_TIME_RATE: "service/reporting/lead-time/",
  COMPLITED_RATE: "service/reporting/complited/",
  RESCHEDULING_RATE: "service/reporting/rescheduled",
  PEAK_BOOKING_TIME: "service/reporting/peak-booking/",
  SERVICE_REPORT_DOWN: "service/reporting/download/",
  SERVICE_REPORT_DOWN_RESULTS: "service/reporting/report/",
  GET_TRANSACTION_REPORTING: "transactions-reporting/summary/",
  GET_TRANSACTION_ITEM_SUMMARY: "transactions-reporting/item-summary/",
  GET_EMPLOYEE_SALES: "transactions-reporting/employee-sales/",
};

class ReportingService extends ApiService {
  getTransactions = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.GET_TRANSACTIONS}?${stringify(payload)}`,
    );
  };

  getSingleTransaction = ({ transactionId }) => {
    return this.apiClient.get(format(ENDPOINTS.GET_TRANSACTION, transactionId));
  };

  deleteTransaction = ({ transactionId }) => {
    return this.apiClient.delete(
      format(ENDPOINTS.DELETE_TRANSACTION, transactionId),
    );
  };

  startTransactionsDownload = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.START_TRANSACTIONS_DOWNLOAD}?${stringify(payload)}`,
    );
  };

  getTransactionsDownloadResults = () => {
    return this.apiClient.get(ENDPOINTS.TRANSACTIONS_DOWNLOAD_RESULTS);
  };

  getMarketingReporting = (filter) => {
    return this.apiClient.get(
      format(ENDPOINTS.GET_MARKETING_REPORTING, filter),
    );
  };

  getCampaignPefromance = () => {
    return this.apiClient.get(ENDPOINTS.GET_CAMPAIGN_PERFORMANCE);
  };

  connectContactAndTransaction = (payload) => {
    return this.apiClient.post(
      ENDPOINTS.CONNECT_CONTACT_AND_TRANSACTION,
      payload,
    );
  };

  removeContactAndTransaction = (payload) => {
    return this.apiClient.post(
      ENDPOINTS.REMOVE_CONTACT_FROM_TRANSACTION,
      payload,
    );
  };

  getTreatments = (payload) => {
    const { employees } = payload;

    if (!employees) {
      delete payload["employees"];
    }
    return this.apiClient.get(
      `${ENDPOINTS.GET_TREATMENTS}?${stringify(payload)}`,
    );
  };

  partialUpdate = (data) => {
    return this.apiClient.patch(
      format(ENDPOINTS.PARTIAL_UPDATE_TRANSACTIONS, data?.id),
      data?.payload,
    );
  };

  connectAppointment = (data) => {
    return this.apiClient.post(
      format(ENDPOINTS.CONNECT_APPOINTMENT, data?.id),
      data?.payload,
    );
  };

  getProductsExtra = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.PRODUCTS_EXTRA}?${stringify(payload)}`,
    );
  };
  getTotalApptScheduled = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.TOTAL_APPT_SCHEDULED}?${stringify(payload)}`,
    );
  };
  getServiceRate = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.TOP_SERVICE_RATE}?${stringify(payload)}`,
    );
  };
  getProvidersProductivity = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.PROVIDERS_PRODUCTIVITY_RATE}?${stringify(payload)}`,
    );
  };
  getStaffUtalization = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.STAFF_UTALIZATION}?${stringify(payload)}`,
    );
  };
  getNoShowRate = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.NO_SHOW_RATE}?${stringify(payload)}`,
    );
  };
  getLeadTimeRate = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.LEAD_TIME_RATE}?${stringify(payload)}`,
    );
  };
  getComplitedRate = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.COMPLITED_RATE}?${stringify(payload)}`,
    );
  };
  getReSchedulingRate = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.RESCHEDULING_RATE}?${stringify(payload)}`,
    );
  };
  getPeakBookkingTime = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.PEAK_BOOKING_TIME}?${stringify(payload)}`,
    );
  };
  startServiceReportDownload = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.SERVICE_REPORT_DOWN}?${stringify(payload)}`,
    );
  };
  getServiceReportDownloadResults = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.SERVICE_REPORT_DOWN_RESULTS}?${stringify(payload)}`,
    );
  };

  getTransactionReporting = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.GET_TRANSACTION_REPORTING}?${stringify(payload)}`,
    );
  };

  getTransactionItemSummary = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.GET_TRANSACTION_ITEM_SUMMARY}?${stringify(payload)}`,
    );
  };

  getEmployeeSales = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.GET_EMPLOYEE_SALES}?${stringify(payload)}`,
    );
  };
}

export default new ReportingService();
